import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ReferralsSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.28293 3.8501C6.01877 3.8501 3.37264 6.49622 3.37264 9.76037C3.37264 11.9394 4.55193 13.843 6.30681 14.8678C4.0828 15.6485 2.2263 17.2783 1.06158 19.3829C0.887334 19.6978 1.00132 20.0943 1.31617 20.2685C1.63102 20.4427 2.02752 20.3288 2.20176 20.0139C3.6198 17.4516 6.17291 15.7438 9.07858 15.6672C9.14641 15.6695 9.21454 15.6706 9.28293 15.6706C9.35132 15.6706 9.41944 15.6695 9.48728 15.6672C12.393 15.7438 14.9461 17.4516 16.3641 20.0139C16.5383 20.3288 16.9348 20.4427 17.2497 20.2685C17.5645 20.0943 17.6785 19.6978 17.5043 19.3829C16.5023 17.5724 14.9885 16.1133 13.1691 15.2438C13.6603 15.143 14.1674 15.0894 14.6858 15.0874L14.7144 15.0875L14.7431 15.0874C17.7214 15.0985 20.349 16.823 21.7955 19.4368C21.9697 19.7517 22.3662 19.8656 22.6811 19.6914C22.9959 19.5171 23.1099 19.1207 22.9357 18.8058C21.7516 16.6662 19.8525 15.0172 17.5791 14.2524C19.0596 13.3062 20.0414 11.648 20.0414 9.76036C20.0414 6.81826 17.6563 4.43322 14.7142 4.43322C13.9645 4.43322 13.2497 4.58847 12.6013 4.86888C11.6553 4.22587 10.5129 3.8501 9.28293 3.8501ZM4.67578 9.76037C4.67578 7.21592 6.73847 5.15324 9.28293 5.15324C11.8274 5.15324 13.8901 7.21592 13.8901 9.76037C13.8901 12.2394 11.9321 14.2611 9.47826 14.3634C9.41332 14.362 9.3482 14.3613 9.28293 14.3613C9.21766 14.3613 9.15255 14.362 9.0876 14.3634C6.63377 14.2611 4.67578 12.2394 4.67578 9.76037ZM15.1932 9.76037C15.1932 8.26545 14.6381 6.90003 13.7229 5.85922C14.0397 5.77902 14.3717 5.73636 14.7142 5.73636C16.9366 5.73636 18.7382 7.53797 18.7382 9.76036C18.7382 11.9737 16.9512 13.7697 14.7413 13.7843L14.7142 13.7842L14.6872 13.7843C14.3543 13.7821 14.0314 13.7396 13.7229 13.6615C14.6381 12.6207 15.1932 11.2553 15.1932 9.76037Z"
        fill={color}
      />
    </svg>
  );
};

export { ReferralsSvg };
